import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Navigation from './Navigation';
import Button from 'components/Form/Button';
import LoginModal from 'apps/user/page/authentication';
import { useAppDispatch } from 'store/hooks';
import { logout } from 'thunks/account-thunk';
interface ISidebarProps {
  setShow: () => void;
  show: boolean;
  name: string | null;
  email: string | null;
  initials: string | null;
}

const Sidebar: React.FC<ISidebarProps> = ({
  name,
  email,
  initials,
  setShow,
  show
}) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [showLoginModal, setShowLoginModal] = useState(false);

  const handleLogout = () => {
    dispatch(logout());
    navigate('', { replace: true });
  };

  return (
    <div
      className={`fixed left-0 top-0 z-50 flex  h-screen w-full ${
        show ? 'animate-fade-in' : 'animate-fade-out'
      }`}
    >
      <div className="top-0 z-50 h-full w-80 max-w-[90%] overflow-auto rounded-r-lg bg-white">
        <div className="mr-5 mt-6 h-full">
          {name && email && (
            <div className="ml-8 flex items-center space-x-4">
              <div className="relative inline-flex h-14 w-14 items-center justify-center overflow-hidden rounded-full bg-primary-800">
                <span className="font-medium text-white">{initials}</span>
              </div>
              <p className="flex flex-col overflow-hidden">
                <span className="font-normal text-black">{name}</span>
                <span className="text-sm text-black ">{email}</span>
              </p>
            </div>
          )}

          <div className="mt-10 space-y-6 border-b border-b-grey-500 pb-8">
            <Navigation
              navClassName="ml-8 flex w-fit normal text-primary-500 px-3s py-2 space-x-4 xsm350:text-base text-sm "
              iconClassName=""
              close={setShow}
            />
          </div>
          <div className="my-5 ml-8 flex flex-col gap-5">
            <span className="text-sm font-bold text-primary-800">
              (01-2499-900)
            </span>
            {!email && (
              <>
                <span
                  className="text-base font-normal"
                  role="button"
                  tabIndex={-1}
                  onKeyDown={() => setShowLoginModal(true)}
                  onClick={() => setShowLoginModal(true)}
                >
                  Login
                </span>
                {/* <Link to="/get-started">
                  <Button
                    variant="primary"
                    size="md"
                    className="w-[7rem] rounded"
                    label="Get Started"
                  ></Button>
                </Link> */}
              </>
            )}
            {email && (
              <Link to="/dashboard">
                <Button
                  variant="primary"
                  size="md"
                  className="w-[7rem] rounded"
                  label="My Account"
                ></Button>
              </Link>
            )}
          </div>
          <div className="mt-6 space-y-6 border-b  border-b-grey-500"></div>

          {email && (
            <button
              className="ml-8 mt-6 flex items-center space-x-3 pb-0 "
              type="button"
              onClick={handleLogout}
            >
              <span className="font-normal text-red-500">Logout</span>
            </button>
          )}
        </div>
      </div>
      <div className="grow" onClick={setShow} aria-hidden="true" />
      {showLoginModal && <LoginModal onDismiss={setShowLoginModal} />}
    </div>
  );
};

export default Sidebar;
